import { REACT_APP_API_URL } from "../../setup/config";
import axios, { handleApiError } from '../axios';

export const getSellerPOItems = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po-item/`, data);
        return await response.data;
    } catch (error) {
        console.log("getSellerPOItems - error", error)
        return handleApiError(error)
    }
}

export const getSellerPOItemById = async (sellerPOItemId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/seller-po-item/${sellerPOItemId}`);
        return await response.data;
    } catch (error) {
        console.log("getSellerPOItemById - error", error)
        return handleApiError(error)
    }
}

export const getSellerPOItemsByDocNos = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po-item/doc-nums`, data);
        return await response.data;
    } catch (error) {
        console.log("getSellerPOItemsByDocNos - error", error)
        return handleApiError(error)
    }
}

export const insertSellerPOItem = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po-item/create`, data);
        return await response.data;
    } catch (error) {
        console.log("insertSellerPOItem - error", error)
        return handleApiError(error)
    }
}

export const updateSellerPOItem = async (sellerPOItemId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po-item/update/${sellerPOItemId}`, data);
        return await response.data;
    } catch (error) {
        console.log("updateSellerPOItem - error", error)
        return handleApiError(error)
    }
}

export const getSellerPOItemsBySellerPOIds = async (sellerPOIds) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po-item/sellerPOIds`, sellerPOIds);
        return await response.data;
    } catch (error) {
        console.log("getSellerPOItemsBySellerPOIds - error", error)
        return handleApiError(error)
    }
}


export const convertToStockQty = async (sellerPOItems) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po-item/convertToStock`, sellerPOItems);
        return await response.data;
    } catch (error) {
        console.log("convertToStockQty - error", error)
        return handleApiError(error)
    }
}

export const updateSellerPOItemsBySellerPOItemIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po-item/remarks`, data);
        return await response.data;
    } catch (error) {
        console.log("updateSellerPOItemsBySellerPOItemIds - error", error)
        return handleApiError(error)
    }
}

export const getFollowUpSellerPOItemsByCompanyId = async (data) => {
    
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po-item/companyId`, data);
        return await response.data;
    } catch (error) {
        console.log("getSellerPOItemsBySellerPOIds - error", error)
        return handleApiError(error)
    }
}

export const updateFollowUpSPOItemsBySellerPOItemId = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po-item/update-followup`, data);
        return await response.data;
    } catch (error) {
        console.log("updateFollowUpSPOItemsBySellerPOItemId - error", error)
        return handleApiError(error)
    }
}

export const getSellerPOItemsRaw = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po-item/search`, data);
        return await response.data;
    } catch (error) {
        console.log("getSellerPOItemsRaw - error", error)
        return handleApiError(error)
    }
}